import React from 'react';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Entities } from '../../../../constants';
import { View } from '../../../View';
import { Text } from '../../../Text';
export const Entity = ({ value }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Text, { type: 'body', weight: 'semibold', size: 'md' }, `{ ${Entities[value].text} }`)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        height: size.J,
        borderRadius: size.C,
        backgroundColor: color.invert2.p4,
        paddingHorizontal: size.B,
        paddingVertical: 1
    }
}));
//# sourceMappingURL=Entity.js.map